export default __webpack_public_path__ + "static/media/growingWall.ad26d860.svg";